import React from 'react'
import T from 'prop-types'

class Checkbox extends React.Component {
  static propTypes = {
    checked: T.bool,
    indeterminate: T.bool,
    className: T.string,
    disabled: T.bool,
    onChange: T.func
  }

  static defaultProps = {
    checked: false,
    disabled: false,
    className: ''
  }

  _onClick = (e) => {
    if (!this.props.disabled) {
      return typeof this.props.onChange === 'function'
        ? this.props.onChange(e)
        : void 0
    }
  }

  render() {
    const {checked, indeterminate, disabled, className, onChange} = this.props
    return (
      <button
        className={`pw_checkbox ${disabled
          ? 'disabled'
          : ''} icon icon-checkbox-${indeterminate ? 'partial' : (checked ? 'checked' : 'unchecked')} ${className}`}
        onClick={this._onClick}
        role="checkbox"
        tabIndex={disabled || !onChange ? -1 : 0}
        aria-checked={indeterminate ? 'mixed' : checked}
        aria-disabled={disabled}
      />
    )
  }
}

export default Checkbox
